import { ReactNode } from "react";
import { motion, MotionStyle } from "framer-motion";
import { CAROUSEL_ITEM_ACTIVATION_DELAY } from "./SectionLayout.constants";

interface TextProps {
    children: ReactNode,
    style?: MotionStyle,
    initial?: boolean,
}

function TextWrapper(props: TextProps) {
    return (
        <motion.div
            style={{
                position: 'absolute',
                whiteSpace: 'pre-line',
                ...props?.style,
            }}
            initial={props.initial ? { opacity: 0 } : false}
            animate={{
                opacity: 1,
                transition: {
                    delay: CAROUSEL_ITEM_ACTIVATION_DELAY,
                    duration: 1
                }
            }}
            exit={{
                opacity: 1,
                y: '-100vh',
                transition: {
                    ease: 'easeIn',
                    duration: 2,
                },
            }}
        >
            {props.children}
        </motion.div>
    )
}

export default TextWrapper;
